export default __webpack_public_path__ + "2125f165e96c7523ebd4e38a549ef2c2.png";